UnexpectedErrorHandlerInterceptor = ($q, $filter, $timeout, flash) ->
  response: (response) ->
    response || $q.when(response)
  responseError: (rejection) ->
    switch
      when rejection.status is 500
        # Because we can't stop event propagation here (always execute .error function after this).
        # we set timeout to make sure this message is final message about  failed request api.
        $timeout ->
          flash.error $filter('translate')('_ERROR_HANDLER.UNEXPECTED_ERROR_MSG')
        , 100
    $q.reject rejection

UnexpectedErrorHandlerInterceptor.$inject = [
  '$q'
  '$filter'
  '$timeout'
  'flash'
]

module.exports = UnexpectedErrorHandlerInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/error-handler/unexpected-error-handler-interceptor.coffee